import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, input, Output, signal, ViewChild } from '@angular/core';
import { Transforms } from '@shared/helpers/transforms';
import { BsDropdownConfig, BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
    selector: 'dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropdownComponent {

  public id = input.required<string>();
  public container = input<string>("");

  @ViewChild("dropdown")
  private dropdown : BsDropdownDirective;

  public disabled = input(false, { transform: Transforms.toBoolean });

  public closeDropdown = () => this.dropdown.hide();

  public openDropdown = () => this.dropdown.show();
}